"use strict";
exports.__esModule = true;
exports.getHeaderBanner = void 0;
var tslib_1 = require("tslib");
var fetch_promotions_1 = require("./fetch-promotions");
var find_header_banner_1 = require("./find-header-banner");
var getHeaderBanner = function (path, token, gymId) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var promotions, e_1;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, (0, fetch_promotions_1.fetchPromotions)({ token: token, path: path, gymId: gymId })];
            case 1:
                promotions = _a.sent();
                return [2, (0, find_header_banner_1.findHeaderBanner)(promotions)];
            case 2:
                e_1 = _a.sent();
                return [2, null];
            case 3: return [2];
        }
    });
}); };
exports.getHeaderBanner = getHeaderBanner;
